<div *ngIf='!preview' class='list-container'>

  <p class='title'>
    {{ title }}
  </p>

  <form *ngIf='!loading'
        [formGroup]='formGroup'
        class='list-checkbox-form'>
    <div *ngFor='let check of checkboxs' class='form-check checkbox-v0-form'>
      <input [checked]='check.checked'
             class='form-check-input cursor-pointer'
             formControlName='{{check.uuid}}'
             id='{{id}}_{{internalId}}_{{check.uuid}}'
             type='checkbox'>
      <div class='form-check-label '>
        <label class='cursor-pointer w-100' for='{{id}}_{{internalId}}_{{check.uuid}}'>
          {{ check.label }}
          <pt-w-help [help]='check?.help'></pt-w-help>
        </label>
      </div>
    </div>
  </form>
</div>


<!--PREVIEW-->
<div *ngIf='preview' class='list-container'>
  <p class='title'>
    <pt-icon [key]='IconDoubleCheck'
             [ngClass]="formGroup?.valid ? 'text-success' : 'text-muted'">
    </pt-icon>
    {{ title }}
  </p>

  <form *ngIf='!loading'
        [formGroup]='formGroup'
        class='list-checkbox-form'>
    <div *ngFor='let check of checkboxPreview'
         class='form-check'>
      <label class='form-check-label d-flex align-items-baseline'>
        <ng-container>
          <pt-icon *ngIf='check.checked' [key]='IconCheck' class='text-success'></pt-icon>
          <pt-icon *ngIf='!check.checked' [key]='IconClose' class='text-danger'></pt-icon>
        </ng-container>
        {{ check.label }}
        <pt-w-help [help]='check?.help'></pt-w-help>
      </label>
    </div>
  </form>
</div>
